import { render, staticRenderFns } from "./responseRight.vue?vue&type=template&id=56cfa2ec&scoped=true"
import script from "./responseRight.vue?vue&type=script&lang=js"
export * from "./responseRight.vue?vue&type=script&lang=js"
import style0 from "./responseRight.vue?vue&type=style&index=0&id=56cfa2ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cfa2ec",
  null
  
)

export default component.exports